import { noGAEventParams, sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * 発火タイミング：虫眼鏡 / Search ボタン押下でキーワード検索モーダルを開いた際。
 * 流入元ページは GA4 標準の `page_location` / `page_path` で分かるため、独自パラメータは持たない。
 */
export const sendGAWabunkaSearchModalOpenEvent = () => {
  sendWabunkaGAEvent('search_modal_open', noGAEventParams);
};
